import * as forms from "@client/forms";
import * as typography from "@client/shared/typography";
import {ManagerLayout} from "@client/site/ManagerLayout";
import {server} from "@reactivated";
import React from "react";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.ManagerSettings) => {
    const settings_form = forms.useForm(props.settings_form);
    return (
        <ManagerLayout title="Settings" narrow currentClientManagerId={null}>
            <form
                method="POST"
                action=""
                className="flex flex-col space-y-[15px]!"
                onSubmit={forms.guard([settings_form])}
            >
                <ClientNavigation>
                    <typography.Header>Settings</typography.Header>
                </ClientNavigation>
                <forms.CSRFToken />
                <forms.FormErrors form={settings_form} />

                <typography.Title>Check-ins</typography.Title>
                <typography.P>
                    Enable or disable questions for client check-ins. To schedule a
                    check-in for a client, visit their planner.
                </typography.P>

                <forms.Fields
                    form={settings_form}
                    fields={[
                        "check_in_sleep",
                        "check_in_hunger",
                        "check_in_stress",
                        "check_in_energy",
                        "check_in_mood",
                    ]}
                />
                <forms.Fields form={settings_form} fields={["check_in_notes_label"]} />
                <typography.Title>Measurements</typography.Title>
                <typography.P>
                    Enable or disable measurements your clients can self-report every
                    day.
                </typography.P>
                <forms.Fields
                    form={settings_form}
                    exclude={[
                        "check_in_sleep",
                        "check_in_hunger",
                        "check_in_stress",
                        "check_in_energy",
                        "check_in_mood",
                        "check_in_notification",
                        "check_in_notes_label",
                        "primary_metric",
                        "secondary_metric",
                        "tertiary_metric",
                        "has_hidden_macros",
                    ]}
                />
                <typography.Title>Dashboard</typography.Title>
                <typography.P>
                    All the measurements you selected above are visible in your reports.
                </typography.P>
                <typography.P>
                    The three selected below will also be shown on your dashboard and
                    track weekly changes.
                </typography.P>
                <div className="m-[-5px] flex flex-wrap items-end *:m-[5px]">
                    <forms.Fields
                        form={settings_form}
                        fields={[
                            "primary_metric",
                            "secondary_metric",
                            "tertiary_metric",
                        ]}
                    />
                </div>
                <typography.Title>Notifications</typography.Title>
                <typography.P>Choose when you would like to be emailed.</typography.P>
                <forms.Fields form={settings_form} fields={["check_in_notification"]} />
                <typography.Title>Beta features</typography.Title>
                <typography.P>
                    These are features we’re testing and still tweaking. Feel free to
                    use them but they may change substantially or disappear entirely.
                </typography.P>
                <forms.Fields form={settings_form} fields={["has_hidden_macros"]} />
                <typography.Button submit>Save</typography.Button>
            </form>
        </ManagerLayout>
    );
};
